export default __webpack_public_path__ + "static/media/logo_loading.e6c29a8b.svg";